import React from "react";
import { Draggable } from "react-beautiful-dnd";
import PolicyIcon from "../../../icons/theme.svg?react";
import CustomIcon from "../../../icons/auditcustomTheme.svg?react";
import { getIconUrl } from "../../../iconUtils";
import styles from "./style.module.scss";


export interface PolicyItem {
  id: string;
  name: string;
  themeCode?: string;
  type: "policy" | "custom";
  country?: string;
  iconType?:
  | "cybersecurity"
  | "cryptography"
  | "it-management"
  | "resilient-management";
  description?: string;
  version?: string;
}

interface PolicyLibraryItemProps {
  item: PolicyItem;
  index: number;
  isHidden?: boolean;
}

const PolicyLibraryItem: React.FC<PolicyLibraryItemProps> = ({
  item,
  index,
  isHidden,
}) => {
  if (isHidden) {
    return null;
  }

  return (
    <Draggable draggableId={item.id} index={index}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className={`${styles.libraryItem} ${snapshot.isDragging ? styles.dragging : ""} ${item.type === "policy" ? styles.policy : styles.theme
            }`}
        >
          <div className={styles.content}>
            <div className={styles.iconContainer}>
              {item?.country && (
                <img
                  src={getIconUrl(item?.country.toLowerCase())}
                  alt={`${item.country} flag`}
                  style={{
                    width:
                      item?.name === "Cyber Security" ||
                        item?.name === "IT Management"
                        ? "25px"
                        : "35px",
                    height: "auto",
                  }}
                />
              )}
            </div>
            <span className={styles.itemName}>{item.name}</span>
          </div>
          <div className={styles.dragHandle}>
            {item?.type === "policy" ? (
              <PolicyIcon className={styles.typeIcon} />
            ) : item?.type === "custom" ? (
              <CustomIcon className={styles.typeIcon} />
            ) : null}
          </div>
        </div>
      )}
    </Draggable>
  );
};

export default PolicyLibraryItem;
